module.exports = __webpack_public_path__ + "img/lock_bottom_hook_box1.6d8770d0.png";